import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-googlemapstatuspopup',
  templateUrl: './googlemapstatuspopup.component.html',
  styleUrls: ['./googlemapstatuspopup.component.scss']
})
export class GooglemapstatuspopupComponent implements OnInit {
  fromPage: string[];
  url: string;
  requestID: string;
  showScreen: string = "vquad";
  rsltType: string = "call-events";

  constructor(private http: HttpClient, public dialogBox: MatDialogRef<GooglemapstatuspopupComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.fromPage = data.pageValue;
    //debugger;
    if (data.pageValue.split('$')[1] == "OFF") {//predefined config off
      let eventdata = data.pageValue.split('$')[0];
      this.requestID = eventdata.split('@')[0];
      if (eventdata.split('@')[1] == "mobileapp")
        this.showScreen = "mobileapp";//eventdata.split('@')[1] == "true" ? true : false;
      else if (eventdata.split('@')[1] == "vmobileapp")////vmobileapp
        this.showScreen = "vmobileapp"; //eventdata.split('@')[1] == "true" ? true : false;
      else
        this.showScreen = "vquad";
    }
    else {
      let eventdata = data.pageValue.split('$')[0];
      this.requestID = eventdata.split('@')[0];
      this.rsltType = eventdata.split('@')[1];
      this.showScreen = "vquad";

    }

  }


  ngOnInit() {

  }

  Close() {
    this.dialogBox.close();
  }

  BindVquadStatusDisplay(ID: number) {

    this.url = environment.urlAddress + '/api/' + 'GoogleMaps/GetMapVquadDataByID?vquadID=' + ID;

    this.GetVQuadStatus_Service(ID).subscribe((res: any) => {
      // console.log(res);
      let rows: any[] = JSON.parse(res) as any[];
      //debugger;
      console.log(rows);


    });
  }

  ///////////////////////////////// Services
  GetVQuadStatus_Service(nodeID: number) {

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<any>(this.url, { headers: headerOptions });

  }



}
